var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarcodeBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Devices / barcode-box-fill",
    clipPath: "url(#clip0_12076_617)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.33203 3H21.332C21.5972 3 21.8516 3.10536 22.0391 3.29289C22.2267 3.48043 22.332 3.73478 22.332 4V20C22.332 20.2652 22.2267 20.5196 22.0391 20.7071C21.8516 20.8946 21.5972 21 21.332 21H3.33203C3.06681 21 2.81246 20.8946 2.62492 20.7071C2.43739 20.5196 2.33203 20.2652 2.33203 20V4C2.33203 3.73478 2.43739 3.48043 2.62492 3.29289C2.81246 3.10536 3.06681 3 3.33203 3ZM6.33203 7V17H9.33203V7H6.33203ZM10.332 7V17H12.332V7H10.332ZM13.332 7V17H14.332V7H13.332ZM15.332 7V17H18.332V7H15.332Z",
    fill: "#E6072C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12076_617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.332031)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeBox);
export default __webpack_public_path__ + "static/media/barcode-box.2ca8956db4e353cb2187beded8a54d29.svg";
export { ForwardRef as ReactComponent };